
import settings from './settings';
import { authHeader } from './authHeader';
import { authService } from './authService';

export function addCompanyProfile(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${settings.API_URL}addcompany`, requestOptions).then(authService.handleResponse);
}

export function getCompany() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };
    return fetch(`${settings.API_URL}company`, requestOptions).then(authService.handleResponse);
}

export function addEmailSetting(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${settings.API_URL}addemail`, requestOptions).then(authService.handleResponse);
}

export function getEmailSetting() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };
    return fetch(`${settings.API_URL}email`, requestOptions).then(authService.handleResponse);
}


export function addAttendanceSetting(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${settings.API_URL}add_attendance_setting`, requestOptions).then(authService.handleResponse);
}

export function getAttendanceSetting() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };
    return fetch(`${settings.API_URL}attendancesetting`, requestOptions).then(authService.handleResponse);
}